<div>
  <button class="to-the-top-btn" (click)="scrollTop()">
    {{ 'CORE.COMPONENTS.TO-THE-TOP' | translate }}
    <div class="material-icons arrow" aria-hidden="true">north</div>
  </button>
</div>
